import { pipe } from 'ramda';

import { buildCmsUrl, CMSApiBase, CMSImageBase, getResponseCMS } from './base';
import { request } from '@/api/base';
import { getResponseCamelization } from '@/helpers/api';
import { isCMSV3 } from '@/helpers/conf';

export interface CMSGameCover extends CMSApiBase {
  gameId: string;
  cover: CMSImageBase;
  gradientColor: string;
}

const GAME_COVERS_LIMIT = 3000;

export const gameCoversCMSV3 = () =>
  request<CMSGameCover[]>({
    url: buildCmsUrl({
      path: 'game-covers',
      limit: GAME_COVERS_LIMIT,
    }),
  });

export const gameCoversCMSV4 = () =>
  request<CMSGameCover[]>({
    url: buildCmsUrl({
      path: 'game-covers',
      limit: GAME_COVERS_LIMIT,
      additionalParams: { populate: 'deep' },
    }),
    transformResponse: pipe(
      getResponseCamelization,
      getResponseCMS<CMSGameCover[]>
    ),
  });

export const gameCoversCMS = isCMSV3 ? gameCoversCMSV3 : gameCoversCMSV4;
